/**
 * Módulo de notificaciones — lista, marcar leída, conteo
 *
 * @param {Object} deps - Dependencias inyectadas
 * @param {Function} deps.authenticatedRequest - Función de request autenticada
 * @returns {Object} Métodos del módulo notificaciones
 */
export function createNotificacionesModule({ authenticatedRequest }) {
  return {
    /**
     * Obtiene lista paginada de notificaciones del usuario actual
     *
     * @param {Object} [params] - Parámetros de consulta
     * @param {number} [params.page=1] - Número de página
     * @param {number} [params.limit=20] - Items por página
     * @returns {Promise<{success: boolean, data: Array, pagination: Object}>}
     */
    async getNotificaciones(params = {}) {
      const qs = new URLSearchParams(params).toString();
      return await authenticatedRequest(qs ? `/api/notificaciones?${qs}` : '/api/notificaciones');
    },

    /**
     * Obtiene conteo de notificaciones no leídas
     *
     * @returns {Promise<{success: boolean, data: {count: number}}>}
     */
    async getNotificacionesNoLeidasCount() {
      return await authenticatedRequest('/api/notificaciones/no-leidas/count');
    },

    /**
     * Marca una notificación como leída
     *
     * @param {number} id - ID de la notificación
     * @returns {Promise<{success: boolean, message: string}>}
     */
    async marcarNotificacionLeida(id) {
      return await authenticatedRequest(`/api/notificaciones/${id}/leer`, { method: 'PUT' });
    },

    /**
     * Marca todas las notificaciones como leídas
     *
     * @returns {Promise<{success: boolean, message: string}>}
     */
    async marcarTodasNotificacionesLeidas() {
      return await authenticatedRequest('/api/notificaciones/leer-todas', { method: 'PUT' });
    }
  };
}
